<script setup>

import doneActionToText from "@/helpers/doneActionToText.js";
import BaseDocumentNotification from "@/Components/notifications/BaseDocumentNotification.vue";

defineProps({
    notification: {
        type: Object,
        required: true
    }
});
</script>

<template>
    <BaseDocumentNotification :notification="notification" :avatar-status="notification.data.action">
        <template #info-text>
            {{ doneActionToText(notification.data.action, notification.data.user) }} ваш документ.
            <span v-if="'response' in notification.data && notification.data.response">
                Ответ: {{ notification.data.response }}
            </span>
        </template>
    </BaseDocumentNotification>
</template>
